import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

interface ClipboardProps {
  text: string;
  className?: string;
}

export const Clipboard = ({ text, className, ...props }: ClipboardProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success("Copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Failed to copy to clipboard");
    }
  };

  return (
    <div className="flex items-center gap-2" {...props}>
      <span className="text-sm font-mono">{text}</span>
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={handleCopy}
        className={cn("h-8 w-8", className)}
      >
        {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
      </Button>
    </div>
  );
};
